import React, { useEffect, useState } from "react";
import "font-awesome/css/font-awesome.min.css";
import Loader from "./Loader";
import "../../src/App.css";
import "../styles/checkboxCustom.css";
import "../styles/generator.css";
import VolumeGauge from './child/powerBi/VolumeGauge';
import Computation from './child/powerBi/Computation';
import Ranking from './child/powerBi/Ranking';
import '../styles/VolumeGauge.css';
import secureLocalStorage from "react-secure-storage";
import { getDashboard } from "../js/api/rbp";
import { SidebarLayout } from "./SidebarLayout";

const PROMOTER_DASHBOARD_CACHE = "TDB-PROMOTER-DASHBOARD";

function getDaysInCurrentMonth() {
  const now = new Date(); // Get the current date
  const year = now.getFullYear(); // Get the current year
  const month = now.getMonth(); // Get the current month (0-indexed)

  return new Date(year, month + 1, 0).getDate(); // Dynamically calculate days
}

export const Dashboard = () => {
  const [dailyPerfomance, setDailyPerfomance] = useState(0);
  const currentDate = new Date();
  const daysInMonth = getDaysInCurrentMonth();
  const todayDate = currentDate.getDate();

  Number.prototype.kFormatter = function () {
    let num = this;
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
  }

  const promoterDetail = JSON.parse(sessionStorage.getItem("userDetails"));
  let cachePerfomanceData = secureLocalStorage.getItem(PROMOTER_DASHBOARD_CACHE);
  cachePerfomanceData = cachePerfomanceData !== null ? cachePerfomanceData : {};
  const [dashboardData, setDashboardData] = useState(cachePerfomanceData);
  const [dataFailed, setDataFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const setPromoterReport = async () => {
    let promoterData = dashboardData;
    
    if (Object.keys(dashboardData).length === 0) {
      setLoading(true);
      await getDashboard(promoterDetail.userId).then((response) => {
          if (response.data.status === "00" && response.data.data.dashboard.length > 0) {
            promoterData = response.data.data;
            promoterData.perf = promoterData.dashboard[0];
            delete promoterData['dashboard'];
            promoterData.perf.targetValue = promoterData.targetValue;
            promoterData.perf.risk = promoterData.risk;
            secureLocalStorage.setItem(PROMOTER_DASHBOARD_CACHE, promoterData); // FRONTEND CACHE
            setDashboardData(promoterData);
          } else {
            setDataFailed(true);
          }
          setLoading(false);
        })
        .catch((error) => {
          setDataFailed(true);
          setLoading(false);
        });
    }

    if (Object.keys(promoterData).length) {
      let dailyPerform = (promoterData.perf.targetValue / daysInMonth) * todayDate;
      dailyPerform = dailyPerform > promoterData.perf.VOL / 1000;
      setDailyPerfomance(dailyPerform)
    }
  }
  useEffect(() => {
    setPromoterReport();
  }, []);

  return (
    <div className="generator-page promoter-dashboard d-flex">
      <SidebarLayout sideNavPosition={3} mainBodyStyle={{ backgroundColor: "#f0f4ff" }}>
        <div className="row">
          <header className="header">
            <h1 className="fw-bold">TONIK</h1>
            <h2 className="mb-4 fw-semibold">Current Monthly Perfomance</h2>
          </header>
          {Object.keys(dashboardData).length ?
            <>
              <div className="col-md-12">
                <div className="row stats-cards">
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-3 stat-card">
                    <div className={dashboardData.perf.BOOKING > dashboardData.perf.CUTOFF ? "card border-0 bg-success" : "card border-0 bg-danger"}>
                      <div className="row g-0">
                        <div className="col-4 align-items-center d-flex justify-content-center">
                          <span className={dashboardData.perf.BOOKING > dashboardData.perf.CUTOFF ? "badge bg-success" : "badge bg-danger"}>
                            <svg className="svg-white" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"> <path d="M0 0h24v24H0V0z" fill="none"></path> <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"></path> </svg>
                          </span>
                        </div>
                        <div className="col-8">
                          <div className="card-body p-2">
                            <p className="card-text mb-2">Booked</p>
                            <h5 className="card-title mb-2 fw-bold">{dashboardData.perf.BOOKING}</h5>
                            <p className="card-text"><small className="fw-semibold">vs CutOff: {dashboardData.perf.CUTOFF}</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-3 stat-card">
                    <div className={dashboardData.perf.FSTPD30 < dashboardData.perf.risk ? "card border-0 bg-success" : "card border-0 bg-danger"}>
                      <div className="row g-0">
                        <div className="col-4 align-items-center d-flex justify-content-center">
                          <span className={dashboardData.perf.FSTPD30 < dashboardData.perf.risk ? "badge bg-success" : "badge bg-danger"}>
                            <svg className="svg-white" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"> <g> <rect fill="none" height="24" width="24"></rect> <g> <path d="M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3L19,3z"></path> </g> <path d="M14,17H7v-2h7V17z M17,13H7v-2h10V13z M17,9H7V7h10V9z"></path> </g> </svg>
                          </span>
                        </div>
                        <div className="col-8">
                          <div className="card-body p-2">
                            <p className="card-text mb-2">FSTPD 30%</p>
                            <h5 className="card-title mb-2 fw-bold">{parseFloat(dashboardData.perf.FSTPD30).toFixed(2)}</h5>
                            <p className="card-text"><small className="fw-semibold">{`vs < ${dashboardData.perf.risk}% risk`}</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-3 stat-card">
                    <div className="card border-0 bg-purple">
                      <div className="row g-0">
                        <div className="col-4 align-items-center d-flex justify-content-center">
                          <span className="badge bg-purple">
                            <svg xmlns="http://www.w3.org/2000/svg" className="svg-white secondary" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0,0h24v24H0V0z" fill="none"></path><g><path d="M19.5,3.5L18,2l-1.5,1.5L15,2l-1.5,1.5L12,2l-1.5,1.5L9,2L7.5,3.5L6,2v14H3v3c0,1.66,1.34,3,3,3h12c1.66,0,3-1.34,3-3V2 L19.5,3.5z M15,20H6c-0.55,0-1-0.45-1-1v-1h10V20z M19,19c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3H8V5h11V19z"></path><rect height="2" width="6" x="9" y="7"></rect><rect height="2" width="2" x="16" y="7"></rect><rect height="2" width="6" x="9" y="10"></rect><rect height="2" width="2" x="16" y="10"></rect></g></svg>
                          </span>
                        </div>
                        <div className="col-8">
                          <div className="card-body p-2">
                            <p className="card-text mb-2">Avg Financed Amt</p>
                            <h5 className="card-title mb-2 fw-bold text-success">{dashboardData.perf.CURR_AFA.kFormatter()}</h5>
                            <p className="card-text"><small className="fw-semibold">vs PrevMonth: {dashboardData.perf.PREV_AFA.kFormatter()}</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="gauge-card">
                  <VolumeGauge actualValue={dashboardData.perf.VOL / 1000} targetValue={dashboardData.perf.targetValue} dailyPerfomance={dailyPerfomance} />
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="row h-100">
                  <div className="col-md-12">
                    <Computation dashboardData={dashboardData.perf} dailyPerfomance={dailyPerfomance} daysInMonth={daysInMonth} todayDate={todayDate} />
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-8 mb-4 ms-auto">
                <Ranking rankData={dashboardData.ranking} promoterData={promoterDetail} />
              </div>
            </> : ""}
          {loading ? <Loader /> : ""}
          {dataFailed ?
            <div className="row">
              <div className="col-md-12">
                <div className="card border-0  p-4 text-center">
                  <h4>Data Not Available at the Moment</h4>
                </div>
              </div>
            </div>
            : ""}
        </div>
      </SidebarLayout>
    </div>
  );
};